import { Union, Record } from "../../../fable_modules/fable-library-js.4.19.3/Types.js";
import { union_type, tuple_type, lambda_type, unit_type, list_type, record_type, class_type, int32_type, string_type } from "../../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { S3Context_$reflection } from "../../../Common/AwsCommon.js";
import { UploadSelection_$reflection, FileComponentSpecs_$reflection } from "../../Shared.js";
import { S3ObjectViewModel_$reflection } from "../../../RAWMap.Models/Api.js";
import { FileData_$reflection } from "../../../Common/FileData.js";

export class DragDropFileSelectorUpdateArgs extends Record {
    constructor(token, numberOfAssociatedFiles, credentials, context) {
        super();
        this.token = token;
        this.numberOfAssociatedFiles = (numberOfAssociatedFiles | 0);
        this.credentials = credentials;
        this.context = context;
    }
}

export function DragDropFileSelectorUpdateArgs_$reflection() {
    return record_type("RAWMap.Client.FileUploadSelectors.DragDropFileSelector.Types.DragDropFileSelectorUpdateArgs", [], DragDropFileSelectorUpdateArgs, () => [["token", string_type], ["numberOfAssociatedFiles", int32_type], ["credentials", class_type("Fable.Import.Aws.Credentials.Credentials")], ["context", S3Context_$reflection()]]);
}

export class Model extends Record {
    constructor(Specs, PathTestFiles, SelectedFiles) {
        super();
        this.Specs = Specs;
        this.PathTestFiles = PathTestFiles;
        this.SelectedFiles = SelectedFiles;
    }
}

export function Model_$reflection() {
    return record_type("RAWMap.Client.FileUploadSelectors.DragDropFileSelector.Types.Model", [], Model, () => [["Specs", FileComponentSpecs_$reflection()], ["PathTestFiles", list_type(S3ObjectViewModel_$reflection())], ["SelectedFiles", list_type(FileData_$reflection())]]);
}

export class LocalMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Noop", "ExnErrorMsg", "ShowErrorToast", "UploadSelectionChanged", "ValidateFiles"];
    }
}

export function LocalMsg_$reflection() {
    return union_type("RAWMap.Client.FileUploadSelectors.DragDropFileSelector.Types.LocalMsg", [], LocalMsg, () => [[], [["Item", class_type("System.Exception")]], [["Item", string_type]], [["Item", list_type(FileData_$reflection())]], [["fileDataList", list_type(FileData_$reflection())], ["onSuccess", lambda_type(Model_$reflection(), tuple_type(Model_$reflection(), list_type(lambda_type(lambda_type(LocalMsg_$reflection(), unit_type), unit_type)), list_type(lambda_type(lambda_type(OutboundMsg_$reflection(), unit_type), unit_type))))]]]);
}

export class OutboundMsg extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["SelectionMade"];
    }
}

export function OutboundMsg_$reflection() {
    return union_type("RAWMap.Client.FileUploadSelectors.DragDropFileSelector.Types.OutboundMsg", [], OutboundMsg, () => [[["Item", UploadSelection_$reflection()]]]);
}

export class InboundMsg extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["ClearFileList"];
    }
}

export function InboundMsg_$reflection() {
    return union_type("RAWMap.Client.FileUploadSelectors.DragDropFileSelector.Types.InboundMsg", [], InboundMsg, () => [[]]);
}

